module.exports = __webpack_public_path__ + "static/img/woman.55825829.svg";